/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventName } from './EventName';
import {
    EventNameFromJSON,
    EventNameFromJSONTyped,
    EventNameToJSON,
} from './EventName';
import type { FactorMethod } from './FactorMethod';
import {
    FactorMethodFromJSON,
    FactorMethodFromJSONTyped,
    FactorMethodToJSON,
} from './FactorMethod';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
} from './PersonHandle';

/**
 * 
 * @export
 * @interface SDKEventAuthenticationFailedV1
 */
export interface SDKEventAuthenticationFailedV1 {
    /**
     * 
     * @type {EventName}
     * @memberof SDKEventAuthenticationFailedV1
     */
    event_name: EventName;
    /**
     * Person ID
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1
     */
    person_id?: string;
    /**
     * 
     * @type {Array<FactorMethod>}
     * @memberof SDKEventAuthenticationFailedV1
     */
    authenticated_methods?: Array<FactorMethod>;
    /**
     * 
     * @type {FactorMethod}
     * @memberof SDKEventAuthenticationFailedV1
     */
    failed_authn_method: FactorMethod;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1
     */
    failure_reason: string;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1
     */
    failure_detail?: string;
    /**
     * 
     * @type {PersonHandle}
     * @memberof SDKEventAuthenticationFailedV1
     */
    handle?: PersonHandle;
    /**
     * 
     * @type {string}
     * @memberof SDKEventAuthenticationFailedV1
     */
    challenge_id?: string;
}

/**
 * Check if a given object implements the SDKEventAuthenticationFailedV1 interface.
 */
export function instanceOfSDKEventAuthenticationFailedV1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "event_name" in value;
    isInstance = isInstance && "failed_authn_method" in value;
    isInstance = isInstance && "failure_reason" in value;

    return isInstance;
}

export function SDKEventAuthenticationFailedV1FromJSON(json: any): SDKEventAuthenticationFailedV1 {
    return SDKEventAuthenticationFailedV1FromJSONTyped(json, false);
}

export function SDKEventAuthenticationFailedV1FromJSONTyped(json: any, ignoreDiscriminator: boolean): SDKEventAuthenticationFailedV1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'event_name': EventNameFromJSON(json['event_name']),
        'person_id': !exists(json, 'person_id') ? undefined : json['person_id'],
        'authenticated_methods': !exists(json, 'authenticated_methods') ? undefined : ((json['authenticated_methods'] as Array<any>).map(FactorMethodFromJSON)),
        'failed_authn_method': FactorMethodFromJSON(json['failed_authn_method']),
        'failure_reason': json['failure_reason'],
        'failure_detail': !exists(json, 'failure_detail') ? undefined : json['failure_detail'],
        'handle': !exists(json, 'handle') ? undefined : PersonHandleFromJSON(json['handle']),
        'challenge_id': !exists(json, 'challenge_id') ? undefined : json['challenge_id'],
    };
}

export function SDKEventAuthenticationFailedV1ToJSON(value?: SDKEventAuthenticationFailedV1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'event_name': EventNameToJSON(value.event_name),
        'person_id': value.person_id,
        'authenticated_methods': value.authenticated_methods === undefined ? undefined : ((value.authenticated_methods as Array<any>).map(FactorMethodToJSON)),
        'failed_authn_method': FactorMethodToJSON(value.failed_authn_method),
        'failure_reason': value.failure_reason,
        'failure_detail': value.failure_detail,
        'handle': PersonHandleToJSON(value.handle),
        'challenge_id': value.challenge_id,
    };
}

